const FeaturePermissionTypes = {
  UTILITIES: 'utilities',
  DEPOSIT: 'deposit',
  PRORATED_RENT: 'prorated-rent',
  LATE_FEE: 'late-fee',
  PET_FEE: 'pet-fee',
  OTHER: 'other',
  RENT_AMOUNT_CHANGE: 'rentAmountChange',
  RENT_TERMS_EXTEND: 'rentTermExtend',
  RESEND_INVITE: 'resendInvite',
  MOVE_IN_COSTS: 'moveInCosts',
  RENT_GUARANTEE: 'rentGuarantee',
  RENTAL_PROTECTION_PAYMENT_PLAN: 'payment-plan',
};

export default FeaturePermissionTypes;
